















































































import Vue from 'vue'
import Component from 'vue-class-component'
import {State} from 'vuex-class'
import {MenuItem, NavigationMode} from '@/store/types'
import About from '@/components/About.vue';

/**
 * Menu de navegación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: { About },
})
export default class SidenavComponent extends Vue {

    public mini = true

    @State(state => state.permanentNavigation)
    public permanentNavigation: boolean

    /**
     * Modo de visualización del menú de navegación
     */
    @State(state => state.navigationMode)
    public mode: NavigationMode

    public get items (): MenuItem[] {
        return [
            ...this.$store.state.menuItems,
        ]
    }

    public get displayNavigation (): boolean {
        return this.$store.state.displayTemporalNavigation
    }

    public set displayNavigation (value: boolean) {
        this.$store.commit('toggleDisplayTemporalNavigation', value)
    }

    public get permanent (): boolean {
        if (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) {
            this.displayNavigation = false
            return false
        }

        return this.permanentNavigation
    }

    public aboutApp = false

    public get isMobile () {
        return this.$vuetify.breakpoint.xs
    }

    public toggleMini () {
        this.mini = !this.mini
    }

    public created () {
        const mode = localStorage.getItem('config.navigationMode')
        if (mode) {
            this.$store.commit('setNavigationMode', mode)
        }
    }
}
